import { apiOrigin, apiUrl, parentOrigin, readApiJson } from "./api";

export type PlaceSuggestion = { placeId: string; text: string };

function parseSuggestions(raw: unknown): PlaceSuggestion[] {
  if (!raw || typeof raw !== "object") return [];
  const rows = (raw as { suggestions?: unknown }).suggestions;
  if (!Array.isArray(rows)) return [];
  const out: PlaceSuggestion[] = [];
  for (const row of rows) {
    if (!row || typeof row !== "object") continue;
    const text = typeof (row as { text?: unknown }).text === "string" ? (row as { text: string }).text.trim() : "";
    const placeId =
      typeof (row as { placeId?: unknown }).placeId === "string" ? (row as { placeId: string }).placeId : "";
    if (!text) continue;
    out.push({ placeId, text });
  }
  return out;
}

async function pull(url: string, fetchImpl: typeof fetch = fetch): Promise<PlaceSuggestion[]> {
  try {
    const res = await fetchImpl(url, { headers: { Accept: "application/json" } });
    if (!res.ok) return [];
    return parseSuggestions(await readApiJson<unknown>(res));
  } catch {
    return [];
  }
}

export function placesUrls(query: string): string[] {
  const encoded = encodeURIComponent(query);
  const parent = `${parentOrigin()}/api/places/autocomplete?q=${encoded}`;
  if (apiOrigin()) return [parent];
  return [apiUrl(`/places?q=${encoded}`), parent];
}

export async function suggestAddresses(
  query: string,
  deps: { fetch?: typeof fetch } = {},
): Promise<PlaceSuggestion[]> {
  const q = query.trim();
  if (q.length < 3) return [];
  const fetchImpl = deps.fetch ?? fetch;
  for (const url of placesUrls(q)) {
    const rows = await pull(url, fetchImpl);
    if (rows.length) return rows;
  }
  return [];
}
